"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var View_1 = require("../View");
var Dialog_1 = require("../Dialog");
var helpers_1 = require("../helpers");
var CSSNoOverflow = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 0;\n    overflow: hidden;\n"], ["\n    min-width: 0;\n    overflow: hidden;\n"])));
exports.Panel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    overflow: hidden;\n\n    ", "\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    overflow: hidden;\n\n    ", "\n"])), CSSNoOverflow);
exports.Tabs = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n\n    ", "\n"], ["\n    box-sizing: border-box;\n    display: flex;\n\n    ", "\n"])), CSSNoOverflow);
var WizardBody = styled_components_1.default(View_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 100%;\n    padding-top: ", ";\n"], ["\n    height: 100%;\n    padding-top: ", ";\n"])), function (_a) {
    var hasTopPadding = _a.hasTopPadding;
    return (hasTopPadding ? helpers_1.SPACING_M : '0');
});
exports.WizardDialog = function (_a) {
    var _b = _a.hasTopPadding, hasTopPadding = _b === void 0 ? true : _b, props = __rest(_a, ["hasTopPadding"]);
    return (react_1.default.createElement(Dialog_1.Dialog, { id: Math.random()
            .toString(16)
            .slice(2), hasSpacing: false, loading: props.loading, header: props.caption || '', actionFooter: props.actions, size: props.size || { height: Dialog_1.DIALOG_SIZE.l, width: Dialog_1.DIALOG_SIZE.l }, onRequestClose: props.onRequestClose, onKeyPress: props.onKeyDown },
        react_1.default.createElement(exports.Tabs, null,
            props.tabs,
            react_1.default.createElement(exports.Panel, null,
                props.header,
                react_1.default.createElement(WizardBody, { hasTopPadding: hasTopPadding, spaceHorizontal: View_1.INDENT.m, spaceBottom: View_1.INDENT.m, root: true, clipped: true, hasYScroll: true, contentMod: View_1.VIEW_CONTENT_MOD.fill }, props.body)))));
};
exports.WizardDialog.displayName = 'WizardDialog';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=WizardDialog.js.map